import axios from 'axios';

const KEY = 'fd3a962fb879d1c392826e0c9a6ea960'

export default axios.create({
    baseURL: 'https://api.openweathermap.org',
    params: { appid: KEY }
});